module.exports = app_supply_listings_fsbo_landing_frbo_plots;